// extracted by mini-css-extract-plugin
export default {"container":"ConfirmBookingDetailsScreen_container__+DJmu","details":"ConfirmBookingDetailsScreen_details__AL0lT"};